import { WidgetPanel } from "@/components/dashboard-grid/WidgetPanel";
import { StackedColumns } from "@/components/dashboard/widgets/StackedColumns";
import { TOUCH_BG } from "@/components/dashboard/widgets/opsColors";
import { weekLabel } from "@shared/weeks";
import type { BdPayload } from "@shared/bdTracker";

const SERIES = [{ key: "email", label: "Email" }, { key: "call", label: "Call" }, { key: "meeting", label: "Meeting" }] as const;

/** Trailing 12 weeks for the selected person, whatever the period: a one-week chart would be one bar. */
export function BdWeeklyChart({ data }: { data: BdPayload }) {
  const person = data.people.find((p) => p.id === data.who);
  return (
    <WidgetPanel
      title="BD activity"
      meta={`${person ? person.name : "everyone"} · per week`}
      action={
        <span className="flex gap-2.5 text-[11px] text-muted-foreground">
          {SERIES.map((s) => (
            <span key={s.key} className="inline-flex items-center gap-1"><span className={`w-2 h-2 rounded-sm ${TOUCH_BG[s.key]}`} />{s.label}</span>
          ))}
        </span>
      }
      bodyClassName="overflow-hidden"
    >
      <StackedColumns
        labels={data.weekly.weeks.map(weekLabel)}
        series={SERIES.map((s) => ({ key: s.key, label: s.label, className: TOUCH_BG[s.key], values: data.weekly[s.key] }))}
        notes={[{ label: "of which meals", values: data.weekly.meal }]}
      />
    </WidgetPanel>
  );
}
